import axiosPrivateInstance from 'middlewares/AxiosInstance'

const getUnityById = (unityId) => axiosPrivateInstance.get(`/unities/${unityId}`)

export default { getUnityById }
